import { useMethodActions } from "@/store/MethodStore";
import { useEffect, useState } from "react";

const BSOD = () => {
  const {setShowBSOD} = useMethodActions()
  const [progress, setProgress] = useState(0);

  useEffect(() => {

    const errorSound = new Audio("./sounds/blue-screen.mp3")
    const rebootSound = new Audio("./sounds/win31.mp3")

    errorSound.play();

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            rebootSound.play()
            setShowBSOD(false);
          }, 1000);
          return 100;
        }
        return prev + 2; // Slower increment for drama
      });
    }, 150);

    return () => clearInterval(interval);
  }, [setShowBSOD]);

  return (
    <div className="fixed top-0 left-0 inset-0 bg-[#0b65ae] bsod-shake text-white font-sans flex flex-col justify-center items-center p-4 z-[9999]">
      <div className="max-w-2xl">
        {/* Sad emoji and main message */}
        <div className="text-8xl mb-6">:(</div>

        <div className="text-3xl mb-6">
          <p>Your portfolio ran into a problem and needs to restart. (Surely gonna blame interns)</p>
          <p className="mt-2">We'll restart for you.</p>
        </div>

        {/* Progress counter */}
        <div className="text-2xl mb-8">
          {progress}% done pretending to fix things... 🥷
        </div>

        {/* QR Code Section */}
        <div className="flex items-center gap-4 mb-8">
          <div className="bg-white p-2">
            <img
              src="./settings/qr-code.png" // Replace with actual QR code image
              alt="QR Code"
              className="w-24 h-24"
            />
          </div>
          <div>
            <p className="text-xl">
              For more information about this issue and possible fixes, scan this QR
            </p>
            <p className="text-xl mt-2">
              If you call a support person, give them this info:
              <br />
              Stop Code: CRITICAL_CUTENESS_OVERLOAD
            </p>
          </div>
        </div>

        {/* Technical Info */}
        <div className="font-mono text-lg bg-black/20 p-4 rounded">
          <p>*** STOP: 0x000000CAFFE (0xBAD_CODE, 0xDEAD_BEEF, 0xCOFFEE, 0xBOOTCAMP)</p>
          <p className="mt-2">*** gsod.sys - Address FEEDFACE base at CAFEBABE, DateStamp 3D1F1EDD</p>
        </div>
      </div>
    </div>
  );
};

export default BSOD;